module.exports = __webpack_public_path__ + "static/media/stadion_small.b37a106a.jpg";